import { VirtualRowList } from 'src/layouts/SidebarV2/components';
import { useSidebarRows } from 'src/layouts/SidebarV2/hooks';

const ScrollableList = () => {
  const sidebarRows = useSidebarRows();
  return <VirtualRowList {...sidebarRows} />;
};

export { ScrollableList };
